import { __awaiter } from "tslib";
import { axiosClient } from '@as-react/common-utils';
const applepayEndpoints = {
    validatemerchant: 'api/applepay/validatemerchant',
    checkout: 'api/applepay/checkout',
    updateShippingAddress: 'api/applepay/update/shippingaddress',
    payment: 'api/applepay/payment',
};
class ApplePayAPI {
    constructor() {
        this.validateMerchant = (servicesApi, validateMerchantData, market) => __awaiter(this, void 0, void 0, function* () {
            const axiosConfig = {
                method: 'POST',
                url: `${servicesApi}${applepayEndpoints.validatemerchant}`,
                headers: {
                    'Content-Type': 'application/json',
                },
                data: validateMerchantData,
                params: { market },
            };
            const result = yield axiosClient.request(axiosConfig);
            return result.data.statusMessage;
        });
        this.initiateCheckout = (servicesApi, storeId) => __awaiter(this, void 0, void 0, function* () {
            const axiosConfig = {
                method: 'POST',
                url: `${servicesApi}${applepayEndpoints.checkout}`,
                params: { storeId },
                withCredentials: true,
            };
            const result = yield axiosClient.request(axiosConfig);
            return result.data;
        });
        this.updateShippingAddress = (servicesApi, paymentContactData) => __awaiter(this, void 0, void 0, function* () {
            const axiosConfig = {
                method: 'POST',
                url: `${servicesApi}${applepayEndpoints.updateShippingAddress}`,
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
                data: paymentContactData,
            };
            const result = yield axiosClient.request(axiosConfig);
            return result.data;
        });
        this.payment = (servicesApi, paymentData) => __awaiter(this, void 0, void 0, function* () {
            const axiosConfig = {
                method: 'POST',
                url: `${servicesApi}${applepayEndpoints.payment}`,
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
                data: paymentData,
            };
            const result = yield axiosClient.request(axiosConfig);
            return result.data;
        });
    }
}
export default new ApplePayAPI();
